import React from 'react';
import styled from 'styled-components';

import { scoringParser } from 'modules/carrier';

const StyledisplayPercentage = styled.div`
  text-align: right;
`;

const Scoring = ({ cellData: carrier }) => {
  const scoring = scoringParser(carrier);

  if (!scoring) {
    return null;
  }

  return (
    <StyledisplayPercentage>
      <b>{scoring}</b>
    </StyledisplayPercentage>
  );
};

export default Scoring;
